<template>
  <span v-if="typeof logo !== 'undefined'">
    <v-card v-if="inCard">
      <v-img
        :src="`${publicPath}img/${logo}`"
      />
    </v-card>
    <v-img
      v-else
      :src="`${publicPath}img/${logo}`"
      class="mx-8"
    />
  </span>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ProjectLogo',
  props: {
    inCard: {
      default: false,
      type: Boolean,
      required: false
    },
    lightLogo: {
      default: undefined,
      type: String,
      required: false
    },
    darkLogo: {
      default: undefined,
      type: String,
      required: false
    }
  },
  data: () => ({
    publicPath: process.env.BASE_URL
  }),
  computed: {
    ...mapState([
      'darkMode'
    ]),
    logo: function () {
      if (this.darkMode === true && typeof this.darkLogo !== 'undefined') {
        return this.darkLogo
      } else {
        return this.lightLogo
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
